import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Card,
  Checkbox,
  Chip,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  Modal,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography
} from "@mui/material";
import React, { memo, useCallback, useEffect, useRef, useState } from "react";
import Paper from "@mui/material/Paper";
import { Postrequestcall } from "../../../request/Postrequest";
import {
  DELETE_CLIENT_TIMESHEET_JOB_IMAGES,
  DELETE_CLIENT_TIMESHEETS,
  FETCH_CLIENT_TIMESHEET_JOBS_V2,
  FETCH_CLIENT_TIMESHEETJOBS_ACTIVITIES_EMPLOYEE,
  SAVE_CLIENT_TIMESHEET_JOB_IMAGES,
  SAVE_CLIENT_TIMESHEETS
} from "../../../constant/Apipath";
import CloseIcon from "@mui/icons-material/Close";
import { useSelector } from "react-redux";
import moment from "moment";
import { BIGrey, BILightGrey } from "../../../assets/helpers";
import AddIcon from "@mui/icons-material/Add";
import CachedIcon from "@mui/icons-material/Cached";
import Loader from "../../../common/Loader";
import CrewTemplateForm from "../crewTemplateForm/CrewTemplateForm";
import PictureViewer from "../../../common/PictureViewer";
import SaveTemplateModal from "../promptModal/SaveTemplateModal";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DeletConfirmModal from "../promptModal/DeletConfirmModal";
import ConfirmModal from "../promptModal/ConfirmModal";
import ViewEmployeedetail from "../ViewTimesheet/ViewEmployeedetail";
import ReplayIcon from "@mui/icons-material/Replay";
import { ClientEnglishFallback } from "../../constant/ClientEnglishFallback";

let CLIENT_COLOR = "#000000";

export default function CrewTimesheetEmployeeClockInClockOut({
  isOpen,
  clientTimesheetId,
  onClose
}) {
  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
  CLIENT_COLOR = selectedClientData?.AccentColor;
  const [data, setData] = useState({});
  const TOKEN = loginData?.accessToken;
  const USER_ID = loginData?.userInformation?.UserId;
  const [lastFetchedTime, setLastFetchedTime] = useState(null);
  const [imageIndex, setImageIndex] = useState(0);
  const [pictureViewerOpen, setPictureViewerOpen] = useState(false);
  const [deleteImageList, setDeleteImageList] = useState([]);
  const imgRef = useRef(null);
  const [loader, setLoader] = useState(false);
  const [showClockOutModal, setShowClockOutModal] = useState(false);
  const [isClockOutConfrim, setIsClockOutConfrim] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [signData, setSigndata] = useState(null);
  const [isSignature, setIssignature] = useState(false);

  const [saveAsTemplateModal, setSaveAsTemplateModal] = useState(false);
  const [newTemplate, setNewtemplate] = useState(false);

  const [empDetail, setEmpdetail] = useState(false);
  const [empData, setEmpdata] = useState(null);

  const {
    TEXT_ACTIVITIES,
    TEXT_IN,
    TEXT_OUT,
    TEXT_HOURS,
    TEXT_QTY,
    TEXT_EMPLOYEE,
    TEXT_NOTES,
    PLACEHOLDER_SOMETHING,
    TEXT_SUGGESTION_TIMESHEET,
    TEXT_TIMESHEET_TOTAL,
    BUTTON_DELETE_TIMESHEET,
    BUTTON_SUBMIT,
    TEXT_LAST_UPDATED_AT
  } = ClientEnglishFallback?.AddTimesheetModal(multiLanguageData?.AddTimesheetModal || {});

  const { TEXT_ACTION_BE_UNDONE, TEXT_SURE_WANT_TO_DELETE_THIS_TIMESHEET } =
    ClientEnglishFallback?.DeletConfirmModal(multiLanguageData?.DeletConfirmModal || {});

  const { TEXT_EMP_CLOCKED_IN, TEXT_SUBMITTING_AUTOMATTCALLY_CLOCK_OUT_EMP, TEXT_CONTINUE } =
    ClientEnglishFallback?.ConfirmModal(multiLanguageData?.ConfirmModal || {});

  const { TEXT_SIGNATURE, TEXT_CLOSE } = ClientEnglishFallback?.Signature(
    multiLanguageData?.Signature || {}
  );

  useEffect(() => {
    if (clientTimesheetId) {
      fetchClientTimesheetData(clientTimesheetId);
    }
  }, [isOpen]);

  const fetchClientTimesheetData = async () => {
    try {
      setLoader(true);
      const timesheetJobObject = {
        PageNr: 1,
        FullSearch: "",
        UserId: USER_ID,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SearchList: [
          {
            ClientTimesheetId: clientTimesheetId
          }
        ]
      };
      const res = await Postrequestcall(FETCH_CLIENT_TIMESHEET_JOBS_V2, timesheetJobObject, TOKEN);
      if (res.status === 200) {
        let getData = res.data.data[0]?.timesheetActivitiesList.map((item) => {
          return {
            ...item,
            expanded: true
          };
        });
        let getHours = res.data.data[0]?.timesheetHoursList.map((item) => {
          return {
            ...item,
            isUndo: false,
            prevHrs: item?.hours
          };
        });
        setData({
          ...res?.data?.data?.[0],
          timesheetActivitiesList: getData,
          timesheetHoursList: getHours
        });
        const now = moment();
        setLastFetchedTime(now.format("h:mm A"));
      }
    } catch (err) {
      console.log("fetchClientTimesheetData-> Error Fetching Client Timesheet Jobs: ", err);
    } finally {
      setLoader(false);
    }
  };

  const convertTimeToDecimal = (timeStr) => {
    if (!timeStr || !timeStr.includes(":")) return "";
    const [hh, mm] = timeStr.split(":").map(Number);
    if (isNaN(hh) || isNaN(mm)) return "";
    const decimal = hh + mm / 60;
    return decimal.toFixed(2); // Keep 2 decimal places
  };

  const getudFieldsString = (data) => {
    try {
      if (!data?.length) {
        return "";
      }
      const fieldsObject = data.reduce((acc, item) => {
        acc[item.id] = item.value === "false" ? 0 : 1;
        return acc;
      }, {});

      return JSON.stringify(fieldsObject);
    } catch (error) {
      console.error("getudFieldsString-> Error processing UD fields: ", error);
      return "";
    }
  };

  const renderTotalHours = () => {
    let totalMinutes = 0;
    data?.timesheetHoursList?.forEach((item) => {
      const [hh, mm] = item.hours.split(":").map(Number);
      if (!isNaN(hh) && !isNaN(mm)) {
        totalMinutes += hh * 60 + mm;
      }
    });
    const totalHours = Math.floor(totalMinutes / 60);
    const totalRemainingMinutes = totalMinutes % 60;
    // Format with leading zero if needed
    const formattedTotal = `${String(totalHours).padStart(2, "0")}:${String(totalRemainingMinutes).padStart(2, "0")}`;
    return formattedTotal ?? "0.00";
  };

  const onSaveCrewtimesheet = async (checkClockOut) => {
    try {
      const hoursIncomplete = data?.timesheetHoursList?.filter(
        (hr) => !hr?.clockInTime || hr?.clockInTime === "00:00" || hr?.clockInTime === "0:00" || !hr?.clockOutTime || hr?.clockOutTime === "00:00" || hr?.clockOutTime === "0:00"
      );

      if (checkClockOut) {
        if (!isClockOutConfrim && hoursIncomplete?.length > 0) {
          return setShowClockOutModal(true);
        }
      }
      setLoader(true);
      let getTotalhors = renderTotalHours();
      const timeSheetJobList = [
        {
          Id: data?.id,
          ClientJobId: data?.clientJobId,
          Notes: data?.notes,
          totalHours: Number(convertTimeToDecimal(getTotalhors)),
          UDFields: getudFieldsString(data?.udFieldsList),
          Deleted: false
        }
      ];
      // Function to map the hours data to the required format
      const mapTimesheetData = (hr, clockOutTime, clockOutLatitude, clockOutLongitude) => {
        const now = moment().format("HH:mm");
        const cin = hr?.clockInTime && hr?.clockInTime !== "00:00" && hr?.clockInTime !== "0:00" ? moment(hr?.clockInTime, "hh:mm a").format("HH:mm") : (isClockOutConfrim ? now : "00:00");
        const cout = hr?.clockOutTime && hr?.clockOutTime !== "00:00" && hr?.clockOutTime !== "0:00" ? moment(hr?.clockOutTime, "hh:mm a").format("HH:mm") : (isClockOutConfrim ? now : "00:00");

        return {
          Id: hr?.id,
          ClientJobId: hr?.clientJobId,
          ClientEmployeeId: hr?.clientEmployeeId,
          ClientJobActivityId: hr?.clientJobActivityId,
          clockInTime: cin,
          clockOutTime: cout,
          clockInLatitude: hr?.clockInLatitude || (isClockOutConfrim ? 0 : 0), // Ideally we would get current location but for now use 0 or original
          clockOutLatitude: clockOutLatitude || (isClockOutConfrim ? 0 : 0),
          clockInLongitude: hr?.clockInLongitude || 0,
          clockOutLongitude: clockOutLongitude || 0,
          hours: Number(convertTimeToDecimal(hr?.hours)),
          isHoursEdit: hr?.isHoursEdit,
          Notes: hr.notes,
          Deleted: false,
          StatusId: 1
        };
      };

      let timesheetZeroInOutList = data?.timesheetHoursList
        ?.filter((hr) => hr.isHoursEdit == true)
        ?.map((hr) => {
          return mapTimesheetData(
            hr,
            hr?.clockOutTime,
            hr?.clockOutLatitude,
            hr?.clockOutLongitude
          );
        });
      let hoursListUpdated = [...timesheetZeroInOutList];

      const _activityList = data?.timesheetActivitiesList?.map((act) => {
        return {
          Id: act?.id,
          ClientJobId: act?.clientJobId,
          ClientActivityId: act?.clientActivityId,
          Qty: act?.qty,
          QtyUnit: act?.qtyUnit,
          Notes: act?.notes,
          UDFields: getudFieldsString(act?.udFieldsList),
          Deleted: false
        };
      });

      const save_TimeSheet_Object = {
        UserId: USER_ID,
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: data?.clientTimesheetId,
            Date: data?.date,
            DateSubmitted: data?.dateSubmitted,
            StatusId: 1,
            TypeId: data?.typeId,
            ClientId: selectedClientData?.ClientId,
            Deleted: false,
            TimeSheetJobList: timeSheetJobList,
            EmployeeList: [],
            TimesheetHoursList: hoursListUpdated,
            ActivityList: _activityList
          }
        ]
      };
      const save_response = await Postrequestcall(
        SAVE_CLIENT_TIMESHEETS,
        save_TimeSheet_Object,
        TOKEN
      );
      let newPictures = data?.pictureList?.filter((pic) => pic?.isNew);
      if (newPictures?.length > 0) {
        await saveTimeSheetImages(newPictures);
      }
      if (deleteImageList?.length > 0) {
        await deleteTimeSheetImages();
      }
      if (save_response?.data?.data[0]?.objData?.TemplateExists == false) {
        setSaveAsTemplateModal(true);
      } else {
        onClose();
      }
    } catch (error) {
      console.log("onSaveCrewtimesheet-> Error When Sacing Client Timesheet: ", error);
    } finally {
      setLoader(false);
    }
  };

  const saveTimeSheetImages = async (newPictures) => {
    try {
      const uploadActivityImage = newPictures?.map(async (images, index) => {
        const formData = new FormData();
        formData.append("Id", 0);
        formData.append("ClientTimesheetId", data?.clientTimesheetId);
        formData.append("ClientTimesheetJobId", data?.id);
        formData.append("ClientActivityId", 0);
        formData.append("ClientJobId", data?.clientJobId);
        formData.append("ModifiedBy", USER_ID);
        formData.append("FileName", images?.file);
        await Postrequestcall(SAVE_CLIENT_TIMESHEET_JOB_IMAGES, formData, TOKEN, true);
      });
      await Promise.all(uploadActivityImage);
    } catch (e) {
      console.log("saveTimeSheetImages-> Wrror Saving Client Timesheet Job Images: ", e);
    }
  };

  const deleteTimeSheetImages = async () => {
    try {
      const deleteId = deleteImageList?.map((pic) => ({ Id: pic?.id }));
      let payload = {
        UserId: USER_ID,
        ReturnRecordId: false,
        ReturnRecordError: true,
        SoftDelete: true,
        DeleteList: deleteId
      };
      await Postrequestcall(DELETE_CLIENT_TIMESHEET_JOB_IMAGES, payload, TOKEN);
    } catch (error) {
      console.log("deleteTimeSheetImages-> Error When Deleting Timesheet Images: ", error);
    }
  };

  const handleRemoveImage = useCallback(
    (picture, index) => {
      const deleteList = [...deleteImageList];
      if (picture.id) {
        deleteList.push({ id: picture?.id });
      }
      setDeleteImageList(deleteList);
      let temp = [...data?.pictureList];
      temp.splice(index, 1);
      setData({ ...data, pictureList: temp });
    },
    [data, deleteImageList]
  );

  const handleAddImage = () => {
    imgRef.current.click();
  };

  const handelImageChange = (event) => {
    let files = Array.from(event.target.files);
    files = files.filter((file) => file.type.startsWith("image/"));
    const newImages = [...data?.pictureList];
    for (let i = 0; i < files.length; i++) {
      newImages.push({
        isNew: true,
        file: files[i]
      });
    }
    setData({ ...data, pictureList: newImages });
    event.target.value = "";
  };

  const onDeleteTimesheetPressed = async () => {
    try {
      const obj = {
        userId: USER_ID,
        returnRecordId: false,
        returnRecordError: true,
        softDelete: false,
        deleteList: [{ id: Number(data?.clientTimesheetId) }]
      };
      let getResponse = await Postrequestcall(DELETE_CLIENT_TIMESHEETS, obj, TOKEN);
      if (getResponse.status === 201) {
        setShowDeleteModal(false);
        onClose();
      }
    } catch (error) {
      console.log("onDeleteTimesheetPressed-> Error When Deleting Client Timesheet: ", error);
    } finally {
    }
  };

  const handleEmpHourChange = (text, index, hrs, isEditedhrs) => {
    let isUndo = false;
    // Remove everything except digits and colon
    const cleaned = text.replace(/[^\d:]/g, "");
    // If cleared
    if (cleaned === "") {
      let updatedData = { ...data };
      updatedData.timesheetHoursList[index] = {
        ...updatedData.timesheetHoursList[index],
        hours: ""
      };
      setData(updatedData);
      return;
    }
    // Remove existing colon to handle reformat
    const digitsOnly = cleaned.replace(":", "").slice(0, 4);
    let formatted = digitsOnly;
    if (digitsOnly.length >= 3) {
      const hh = digitsOnly.slice(0, 2);
      const mm = digitsOnly.slice(2);
      // Ensure minutes are not more than 59
      if (parseInt(mm) > 59) {
        return; // Or optionally, set it to "59" if you want to auto-correct
      }
      formatted = `${hh}:${mm}`;
    } else if (digitsOnly.length >= 1 && digitsOnly.length <= 2) {
      formatted = `${digitsOnly}`;
    }
    // if (hrs?.clockInTime !== "00:00" && hrs?.clockOutTime !== "00:00") {
    if (hrs.prevHrs !== formatted) {
      isUndo = true;
    }
    // }
    let updatedData = { ...data };
    updatedData.timesheetHoursList[index] = {
      ...updatedData.timesheetHoursList[index],
      hours: formatted,
      isUndo: isUndo,
      isHoursEdit: isEditedhrs || false
    };
    setData(updatedData);
  };

  const handelHoursBlur = (index) => {
    const hourEntry = data.timesheetHoursList.find((item) => item.id === index);
    if (!hourEntry) return;
    let value = hourEntry.hours?.toString().trim() || "";
    let formattedValue = value;
    if (/^\d+$/.test(value)) {
      formattedValue = `${value}:00`;
    } else if (/^\d+:$/.test(value)) {
      formattedValue = `${value}00`;
    } else if (/^(\d+):(\d{1,2})$/.test(value)) {
      const [_, hours, minutes] = value.match(/^(\d+):(\d{1,2})$/);
      const paddedMinutes = minutes.padStart(2, "0");
      formattedValue = `${hours}:${paddedMinutes}`;
    }
    setData((prev) => ({
      ...prev,
      timesheetHoursList: prev.timesheetHoursList.map((item) =>
        item.id === index ? { ...item, hours: formattedValue, isFocused: true } : item
      )
    }));
  };

  const handleUndoChange = (index, hrs) => {
    let updatedData = { ...data };
    updatedData.timesheetHoursList[index] = {
      ...updatedData.timesheetHoursList[index],
      hours: hrs?.prevHrs,
      isUndo: false
    };
    setData(updatedData);
  };

  const onJobActivityQtyChange = (e, index) => {
    let updatedData = { ...data };
    updatedData.timesheetActivitiesList[index] = {
      ...updatedData.timesheetActivitiesList[index],
      qty: e.target.value
    };
    setData(updatedData);
  };

  const onActivityUdfieldChange = (e, actIndex, index) => {
    let updatedData = { ...data };
    let getActivity = updatedData?.timesheetActivitiesList.map((item, aindex) => {
      if (actIndex === aindex) {
        let udFieldJsonString = {};
        let udList = item.udFieldsList.map((item, udIndex) => {
          if (udIndex === index) {
            return {
              ...item,
              value: e?.target?.value === "false" ? "true" : "false"
            };
          }
          return item;
        });
        udList.forEach((field) => {
          let isChecked = field.value === "true";
          if (isChecked) {
            udFieldJsonString[field?.id] = 1;
          } else {
            udFieldJsonString[field?.id] = 0;
          }
        });
        let udFieldsString = JSON.stringify(udFieldJsonString);
        return {
          ...item,
          udFieldsList: udList,
          udFields: udFieldsString
        };
      }
      return item;
    });
    setData({ ...updatedData, timesheetActivitiesList: getActivity });
  };

  const showDeleteTimesheetDialog = () => setShowDeleteModal(true);

  const saveTemplateHandler = async () => {
    setNewtemplate(true);
  };

  const showSignature = async (item) => {
    setSigndata({ clientEmployeeName: item?.clientEmployeeName, signature: item?.signatureUrl });
    setIssignature(true);
  };

  const openEmpdetail = (hrs) => {
    setEmpdetail(true);
    setEmpdata(hrs);
  };

  const ImgUrl = (file) => {
    try {
      let url = URL?.createObjectURL(file);
      return url;
    } catch (error) {
      return file;
    }
  };

  const pictureListArray =
    data?.pictureList?.map((item) => {
      return {
        src: item?.fileUrl || ImgUrl(item?.file)
      };
    }) || [];

  const onJobUdFieldsChange = (e, udIndex) => {
    setData((prev) => ({
      ...prev,
      udFieldsList: prev?.udFieldsList?.map((item, index) => {
        if (index === udIndex) {
          return {
            ...item,
            value: e?.target?.value === "false" ? "true" : "false"
          };
        }
        return item;
      })
    }));
  };

  return (
    <>
      <DeletConfirmModal
        title={TEXT_ACTION_BE_UNDONE}
        heading={TEXT_SURE_WANT_TO_DELETE_THIS_TIMESHEET}
        onConfirm={() => onDeleteTimesheetPressed()}
        isOpen={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
      />

      <ConfirmModal
        confirmButtonText={TEXT_CONTINUE}
        isOpen={showClockOutModal}
        title={
          <Stack>
            <Typography variant="h6" sx={{ color: "#000" }}>
              {TEXT_EMP_CLOCKED_IN}
            </Typography>{" "}
            <Typography sx={{ fontSize: "14px" }}>
              {TEXT_SUBMITTING_AUTOMATTCALLY_CLOCK_OUT_EMP}
            </Typography>{" "}
          </Stack>
        }
        onConfirm={() => {
          setIsClockOutConfrim(true);
          setShowClockOutModal(false);
          onSaveCrewtimesheet(false);
        }}
        onClose={() => {
          setIsClockOutConfrim(false);
          setShowClockOutModal(false);
        }}
      />

      <SaveTemplateModal
        isOpen={saveAsTemplateModal}
        onClose={() => {
          setSaveAsTemplateModal(false);
          onClose();
        }}
        onSave={() => saveTemplateHandler()}
      />

      <PictureViewer
        isOpen={pictureViewerOpen}
        viewerIndex={imageIndex}
        pictures={pictureListArray}
        onClose={() => setPictureViewerOpen(false)}
      />

      {newTemplate && (
        <CrewTemplateForm
          timeSheetData={data}
          from="CrewTimesheet"
          isOpen={newTemplate}
          onClose={() => {
            setSaveAsTemplateModal(false);
            setNewtemplate(false);
            onClose();
          }}
          templateId={0}
        />
      )}

      <ViewEmployeedetail
        isOpen={empDetail}
        onClose={() => setEmpdetail(false)}
        getItem={empData}
      />

      <Modal
        open={isOpen}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box
          sx={{
            padding: {
              xs: "10px",
              xl: "15px",
              lg: "15px",
              md: "15px",
              sm: "10px"
            },
            backgroundColor: "rgb(235, 235, 235)"
          }}
          className="client-modal-responsive">
          <Grid
            sx={{
              minHeight: "70vh",
              maxHeight: "70vh",
              overflow: "scroll",
              scrollbarWidth: "none"
            }}
            container
            spacing={1}>
            {loader ? (
              <Stack sx={{ alignItems: "center", justifyContent: "center" }} width={"100%"}>
                <Loader />
              </Stack>
            ) : (
              <>
                <Stack sx={{ display: "flex",  mb: 1,  justifyContent: "space-between", alignItems: "center" }}   direction={"row"} width={"100%"}>
                  <IconButton onClick={onClose} style={{ padding: "4px" }}>
                    <CloseIcon />
                  </IconButton>
                  <Typography sx={{ color: BIGrey,  fontSize: 14 }} >
                    {lastFetchedTime ? `${TEXT_LAST_UPDATED_AT} ${lastFetchedTime}` : ""}
                  </Typography>
                  <CachedIcon
                    style={{ cursor: "pointer", color: CLIENT_COLOR }}
                    onClick={() => fetchClientTimesheetData(clientTimesheetId)}
                  />
                </Stack>
                <Stack>
                  <Typography variant="h5" fontStyle={"normal"} sx={{ fontWeight: 400 }}>
                    {moment(data?.date ?? "").format("MMMM DD, YYYY")}
                  </Typography>
                  <Typography sx={{ color: BIGrey, fontWeight: 400 }} variant="h6" fontStyle={"normal"}>
                    {data?.clientJobCode} - {data?.clientJobName}
                  </Typography>
                </Stack>
                <Grid size={12}>
                  <Accordion
                    sx={{ background: "transparent", boxShadow: "none" }}
                    defaultExpanded={true}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      sx={{
                        minHeight: "32px !important", // reduce overall height
                        "&.Mui-expanded": {
                          minHeight: "32px !important" // reduce height when expanded
                        },
                        "& .MuiAccordionSummary-content": {
                          margin: "10px 0 !important"
                        },
                        padding: "0px"
                      }}>
                      <Typography variant="h6" fontStyle={"normal"} sx={{ fontWeight: 500 }}>
                        {TEXT_ACTIVITIES}
                      </Typography>
                    </AccordionSummary>
                    {data?.timesheetActivitiesList?.map((act, index) => (
                      <AccordionDetails
                        sx={{
                          borderRadius: "10px",
                          padding: "0px",
                          marginBottom: "10px",
                          boxShadow: "none"
                        }}
                        className="pagelist-content">
                        <Stack style={{ padding: "12px" }}>
                          <Typography variant="h6">
                            {act?.clientJobActivityCode} - {act?.clientJobActivityName}
                          </Typography>
                        </Stack>
                        <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
                          <Table
                            sx={{
                              minWidth: 350,
                              "& th": {
                                color: BIGrey,
                                padding: "0px 10px",
                                borderBottom: "0px"
                              },
                              "& td": {
                                padding: "0px 10px/"
                              }
                            }}
                            aria-label="simple table">
                            <TableHead>
                              <TableRow>
                                <TableCell variant="h6">{TEXT_EMPLOYEE}</TableCell>
                                <TableCell variant="h6">{TEXT_IN}</TableCell>
                                <TableCell variant="h6">{TEXT_OUT}</TableCell>
                                <TableCell variant="h6" sx={{ textAlign: "center" }}>
                                  {TEXT_HOURS}
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {data?.timesheetHoursList?.map(
                                (hrs, index) =>
                                  hrs?.clientJobActivityId === act?.clientActivityId && (
                                    <TableRow
                                      key={index}
                                      sx={{ "& td, & th": { border: 0, padding: "7px" } }}>
                                      <TableCell>
                                        <Stack sx={{ alignItems: "center", cursor:
                                              hrs?.notes != "" || hrs?.pictureList?.length != 0
                                                ? "pointer"
                                                : "" }} direction={"row"} gap={"7px"} onClick={() => openEmpdetail(hrs)}>
                                          <Typography>{hrs.clientEmployeeName}</Typography>
                                          {/* {hrs?.notes != "" || hrs?.pictureList?.length != 0 ? (
                                            <Typography
                                              style={{
                                                borderRadius: 50,
                                                width: 6,
                                                height: 6,
                                                backgroundColor: CLIENT_COLOR
                                              }}></Typography>
                                          ) : null} */}
                                        </Stack>
                                      </TableCell>
                                      <TableCell>
                                        {hrs?.clockInTime == "00:00" ? "--:--" : hrs?.clockInTime}
                                      </TableCell>
                                      <TableCell>
                                        {hrs?.clockOutTime == "00:00" ? "--:--" : hrs?.clockOutTime}
                                      </TableCell>

                                      <TableCell sx={{ textAlign: "center" }}>
                                        <TextField
                                          hiddenLabel
                                          size="small"
                                          placeholder="--:--"
                                          value={
                                            hrs?.hours === "00:00"
                                              ? "--:--"
                                              : hrs?.hours?.toString()
                                          }
                                          onChange={(e) =>
                                            handleEmpHourChange(e.target.value, index, hrs, true)
                                          }
                                          onBlur={() => handelHoursBlur(hrs?.id)}
                                          InputProps={{
                                            endAdornment: hrs.isUndo ? (
                                              <InputAdornment position="end">
                                                <IconButton
                                                  edge="end"
                                                  size="small"
                                                  onClick={() => handleUndoChange(index, hrs)}>
                                                  <ReplayIcon
                                                    sx={{ color: CLIENT_COLOR }}
                                                    fontSize="small"
                                                  />
                                                </IconButton>
                                              </InputAdornment>
                                            ) : (
                                              <></>
                                            )
                                          }}
                                          sx={{
                                            "& fieldset": { border: "none" },
                                            "& input": { textAlign: "center" }
                                          }}
                                          style={{
                                            width: "100px",
                                            backgroundColor: "rgba(0, 0, 0, 0.08)",
                                            borderRadius: "5px",
                                            borderColor: "transparent"
                                          }}
                                        />
                                      </TableCell>
                                    </TableRow>
                                  )
                              )}
                            </TableBody>
                          </Table>
                        </TableContainer>
                        <Stack
                          sx={{
                            padding: "12px",
                            background: "rgb(250, 250, 250)",
                            borderBottomRightRadius: "10px",
                            borderBottomLeftRadius: "10px"
                          }}>
                          {act?.isQuantityApplicable && (
                            <Stack
                              direction={"row"}
                              sx={{ margin: "5px 0px",  alignItems: "center" }}
                              gap={2}
                              >
                              <Typography>{TEXT_QTY}</Typography>
                              <TextField
                                hiddenLabel
                                size="small"
                                value={act?.qty}
                                onChange={(e) => onJobActivityQtyChange(e, index)}
                                onKeyDown={(e) => {
                                  const allowedKeys = [
                                    "Backspace",
                                    "Tab",
                                    "ArrowLeft",
                                    "ArrowRight",
                                    "Delete"
                                  ];
                                  // Allow digits and control keys
                                  if (!/^[0-9]$/.test(e.key) && !allowedKeys.includes(e.key)) {
                                    e.preventDefault();
                                  }
                                }}
                                type="number"
                                name="qty"
                                sx={{
                                  width: "70px",
                                  borderColor: "transparent",
                                  backgroundColor: "rgba(0, 0, 0, 0.08)",
                                  borderRadius: "5px",
                                  textAlign: "center",
                                  "& input": {
                                    textAlign: "center",
                                    MozAppearance: "textfield" // For Firefox
                                  },
                                  "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                                  {
                                    WebkitAppearance: "none",
                                    margin: 0
                                  },
                                  "& fieldset": {
                                    border: "none"
                                  }
                                }}
                              />
                              <Typography>{act?.qtyUnit}</Typography>
                            </Stack>
                          )}
                          {act?.udFieldsList.map((actUd, udIndex) => (
                            <Grid size={12}>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    value={actUd?.value}
                                    checked={actUd?.value === "false" ? false : true}
                                    onChange={(e) => onActivityUdfieldChange(e, index, udIndex)}
                                    sx={{
                                      color: CLIENT_COLOR,
                                      "&.Mui-checked": {
                                        color: CLIENT_COLOR
                                      }
                                    }}
                                  />
                                }
                                label={actUd?.label}
                              />
                            </Grid>
                          ))}
                        </Stack>
                      </AccordionDetails>
                    ))}
                    <Stack sx={{ padding: "15px 0px",  justifyContent: "space-between", alignItems: "center" }} direction={"row"} >
                      <Typography variant="h6">{TEXT_TIMESHEET_TOTAL}</Typography>
                      <Typography variant="h6">{renderTotalHours()}</Typography>
                    </Stack>
                  </Accordion>
                </Grid>
                <Grid size={12}>
                  <Accordion
                    sx={{ background: "transparent", boxShadow: "none" }}
                    defaultExpanded={true}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      sx={{
                        minHeight: "32px !important", // reduce overall height
                        "&.Mui-expanded": {
                          minHeight: "32px !important" // reduce height when expanded
                        },
                        "& .MuiAccordionSummary-content": {
                          margin: "10px 0 !important"
                        },
                        padding: "0px"
                      }}>
                      <Typography variant="h6" fontStyle={"normal"} sx={{ fontWeight: 500 }}>
                        {TEXT_EMPLOYEE}
                      </Typography>
                    </AccordionSummary>
                    {data?.timesheetEmployeesList?.map((item) => (
                      <AccordionDetails
                        sx={{ borderRadius: "10px", padding: "0px", marginBottom: "10px" }}
                        className="pagelist-content">
                        <Stack
                          onClick={
                            item?.isSignature
                              ? (e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                showSignature(item);
                              }
                              : (e) => {
                                e.preventDefault();
                                e.stopPropagation();
                              }
                          }
                          sx={{
                            cursor: item?.isSignature ? "pointer" : "initial",
                            padding: "12px"
                          }}>
                          <Stack sx={{ justifyContent: "space-between", alignItems: "center" }} direction={"row"}>
                            <Stack direction={"row"} sx={{ gap: 1,  alignItems: "center"  }} >
                              <Typography variant="h6">{item?.clientEmployeeName}</Typography>
                              {item?.isSignature && (
                                <CheckCircleIcon fontSize="13" sx={{ color: CLIENT_COLOR }} />
                              )}
                            </Stack>
                            <Typography sx={{ color: BIGrey }}>
                              {item?.mileage} {item?.mileageUnit}
                            </Typography>
                          </Stack>
                          <Stack direction={"row"}  sx={{ gap: "10px", marginTop: "10px" }}>
                            {item?.udFieldsList.map(
                              (data, index) =>
                                data.value == "true" && (
                                  <Chip
                                    key={index}
                                    size="small"
                                    sx={{ borderRadius: "5px" }}
                                    label={data?.label}
                                  />
                                )
                            )}
                          </Stack>
                        </Stack>
                      </AccordionDetails>
                    ))}
                  </Accordion>
                </Grid>
                <Grid size={12}>
                  <Accordion
                    sx={{ background: "transparent", boxShadow: "none" }}
                    defaultExpanded={true}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      sx={{
                        minHeight: "32px !important", // reduce overall height
                        "&.Mui-expanded": {
                          minHeight: "32px !important" // reduce height when expanded
                        },
                        "& .MuiAccordionSummary-content": {
                          margin: "10px 0 !important"
                        },
                        padding: "0px"
                      }}>
                      <Typography variant="h6" fontStyle={"normal"} sx={{ fontWeight: 500 }}>
                        {TEXT_NOTES}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails
                      sx={{ borderRadius: "10px", padding: "0px", marginBottom: "10px" }}
                      className="pagelist-content">
                      <Stack style={{ padding: "12px" }}>
                        <TextField
                          placeholder={PLACEHOLDER_SOMETHING}
                          hiddenLabel
                          multiline
                          rows={2}
                          fullWidth
                          value={data?.notes}
                          sx={{
                            marginTop: 1,
                            backgroundColor: "rgba(0, 0, 0, 0.08)",
                            borderRadius: "5px",
                            "& fieldset": { border: "none" }
                          }}
                          onChange={(e) => {
                            e.preventDefault();
                            let inputValue = e.target.value;
                            inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
                            const updatedData = { ...data };
                            updatedData.notes = inputValue;
                            setData(updatedData);
                          }}
                        />
                        <Grid sx={{ gap: 2,  marginTop: 2,  display: "flex"  }} size={12}  >
                          <div
                            onClick={handleAddImage}
                            style={{
                              cursor: "pointer",
                              height: "100px",
                              minWidth: "100px",
                              border: "1px solid #e4e4e4",
                              borderRadius: "10px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center"
                            }}>
                            <AddIcon />
                          </div>
                          <div
                            style={{
                              display: "flex",
                              gap: "10px",
                              maxWidth: "100%",
                              height: "100%",
                              scrollbarWidth: "none",
                              overflow: "scroll"
                            }}>
                            {data?.pictureList?.length > 0 && (
                              <ImageMemoComponent
                                setPictureIndex={setImageIndex}
                                setPictureViewerOpen={setPictureViewerOpen}
                                uploadedImageList={data?.pictureList}
                                handleRemoveImage={handleRemoveImage}
                              />
                            )}
                          </div>
                          <input
                            onChange={handelImageChange}
                            type="file"
                            id="file"
                            ref={imgRef}
                            style={{ display: "none" }}
                            multiple
                            accept="image/png, image/jpeg, image/jpg"
                          />
                        </Grid>
                      </Stack>
                      {data?.udFieldsList?.length > 0 && (
                        <Stack direction={"row"}  sx={{ gap: "10px", padding: 1 }}>
                          {data?.udFieldsList.map((actUd, udIndex) => (
                            <FormControlLabel
                              control={
                                <Checkbox
                                  value={actUd?.value}
                                  checked={actUd?.value === "false" ? false : true}
                                  onChange={(e) => onJobUdFieldsChange(e, udIndex)}
                                  sx={{
                                    color: CLIENT_COLOR,
                                    "&.Mui-checked": {
                                      color: CLIENT_COLOR
                                    }
                                  }}
                                />
                              }
                              label={actUd?.label}
                            />
                          ))}
                        </Stack>
                      )}
                    </AccordionDetails>
                  </Accordion>
                </Grid>
                <Typography sx={{ color: BIGrey,  marginTop: "10px",  fontSize: "13px", fontWeight: 400 }} variant="h6"  >
                  {TEXT_SUGGESTION_TIMESHEET}
                </Typography>
                <Button
                  style={{ cursor: "pointer" }}
                  sx={{
                    color: CLIENT_COLOR,
                    textAlign: "center",
                    textTransform: "initial",
                    margin: "5px 0px"
                  }}
                  fullWidth
                  onClick={() => showDeleteTimesheetDialog()}>
                  {BUTTON_DELETE_TIMESHEET}
                </Button>
                <Button
                  fullWidth
                  sx={{
                    backgroundColor: CLIENT_COLOR,
                    color: "white",
                    borderRadius: "10px",
                    textTransform: "none"
                  }}
                  onClick={() => onSaveCrewtimesheet(true)}>
                  {BUTTON_SUBMIT}
                </Button>
              </>
            )}
          </Grid>
        </Box>
      </Modal>

      <Modal
        open={isSignature}
        onClose={() => setIssignature(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box
          sx={{
            padding: {
              xs: "10px",
              xl: "15px",
              lg: "15px",
              md: "15px",
              sm: "10px"
            },
            backgroundColor: "rgb(235, 235, 235)",
            maxWidth: "450px"
          }}
          className="client-modal-responsive">
          <Stack sx={{ mb: 1 }}>
            <Typography variant="h6">{signData?.clientEmployeeName}</Typography>
          </Stack>
          <Stack>
            <Typography sx={{ mb: 1 }}>{TEXT_SIGNATURE}</Typography>
            <Card
              className="pagelist-content"
              sx={{ background: "transparent", display: "flex", justifyContent: "center" }}>
              <img
                loading="lazy"
                src={signData?.signature}
                alt={"NO data"}
                style={{
                  cursor: "pointer",
                  height: "100px",
                  borderRadius: "10px"
                }}
              />
            </Card>
          </Stack>
          <Stack sx={{ marginTop: "16px",  alignItems: "center" }} >
            <Button
              sx={{
                backgroundColor: "rgba(0, 0, 0, 0.08)",
                color: "#000",
                borderRadius: "10px",
                textTransform: "none",
                minWidth: "200px",
                fontSize: "15px"
              }}
              onClick={() => setIssignature(false)}>
              {TEXT_CLOSE}
            </Button>
          </Stack>
        </Box>
      </Modal>
    </>
  );
}

const ImageList = ({
  uploadedImageList,
  handleRemoveImage,
  setPictureIndex,
  setPictureViewerOpen
}) => {
  const ImgUrl = (file) => {
    try {
      let url = URL.createObjectURL(file);
      return url;
    } catch (error) {
      return file;
    }
  };

  return uploadedImageList?.map((picture, index) => (
    <div style={{ position: "relative", height: "100px" }} key={index}>
      <img
        loading="lazy"
        onClick={() => {
          setPictureViewerOpen(true);
          setPictureIndex(index);
        }}
        src={picture?.fileUrl || ImgUrl(picture?.file)}
        alt={"NO data"}
        style={{
          cursor: "pointer",
          width: "100px",
          height: "100px",
          borderRadius: "10px"
        }}
      />
      <IconButton
        onClick={() => handleRemoveImage(picture, index)}
        style={{
          position: "absolute",
          top: 0,
          right: 0,
          padding: "5px",
          backgroundColor: BILightGrey,
          color: "white"
        }}>
        <CloseIcon style={{ fontSize: "16px" }} />
      </IconButton>
    </div>
  ));
};

const ImageMemoComponent = memo(ImageList);

